import Phaser, {
    Scene
} from 'phaser'
import {
    CST
} from '../CST'
import $ from "jquery"


var clickSound;
var timerSound;
var correctSound;
var wrongSound;
var statements = new Array();
var current_statement;
var statement_index;
var end;
var pop_up_statement;

export default class StatementScene extends Phaser.Scene {

    constructor() {
        super(CST.SCENES.STATEMENT)
    }

    init() {
        statement_index = 0;
        end = false;
    }

    preload() {
        loadQuestionsFromDatabase();
    }

    create(data) {

        // nextGROUND AND VISUALS

        clickSound = this.sound.add("clickSound", {
            volume: 0.75
        });
        timerSound = this.sound.add("timerSound", {
            volume: 0.75
        });
        correctSound = this.sound.add("correctSound", {
            volume: 0.5
        });
        wrongSound = this.sound.add("wrongSound", {
            volume: 0.5
        });


        current_statement = nextStatement();

        const boardScene = this.scene.get(data.scene);

        if (this.textures.exists("statement_card")) this.textures.remove("statement_card")
        this.load.image("statement_card", current_statement.statement).start();
        this.load.on("complete", () => {
            pop_up_statement = this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'statement_card');

            var next = this.add.image(this.cameras.main.width / 2, (this.cameras.main.height / 2) + 336, 'btn_next');
            next.setInteractive({
                useHandCursor: true
            });
            next.on("pointerdown", () => {
                clickSound.play();

                var direction = current_statement.direction;
                var squares = current_statement.squares;

                current_statement = nextStatement();

                pop_up_statement.destroy();
                this.textures.remove("statement_card");

                this.load.image("statement_card", current_statement.statement).start();

                this.scene.pause();
                this.scene.resume(boardScene.scene.key, {
                    type: 1,
                    direction: direction,
                    squares: squares,
                    end: end,
                    scene: CST.SCENES.QUESTION
                });
                this.scene.sendToBack();
            });
        });


    }

    update() {}
}

function loadQuestionsFromDatabase() {
    var websiteBaseUrl = "website/";
    $.ajax({
        async: false,
        type: "get",
        url: websiteBaseUrl + 'get_magic_questions_to_json.php',
        dataType: 'JSON',
        success(data) {
            statements = data;
        }
    }).responseJSON;
};


function randomiseStatements(array) {
    for (var i = array.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = array[i];
        array[i] = array[j];
        array[j] = temp;
    }
    return array;
};

function nextStatement() {
    if (statement_index != statements.length) {
        current_statement = statements[statement_index];
        statement_index++;
        return current_statement;
    } else {
        statements = randomiseStatements(statements);
        statement_index = 0;
        current_statement = statements[statement_index];
        statement_index++;
        end = true;
        return current_statement;
    }
}